import css from "../css/container.module.css";

export const Container = ({children, bottom}) => {
    return (
        <div className={css.container} style={{height: `calc(100% - ${bottom}px)`}}>
            {children}
        </div>
    )
}
